var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.563 9.267-1.971-4.918a2.371 2.371 0 0 0-2.22-1.516c-.121 0-.241.01-.36.026l-5.245.752A2.339 2.339 0 0 0 7.02 4.792L2.06 13.385a2.4 2.4 0 0 0-.239 1.829 2.395 2.395 0 0 0 1.121 1.464l7.216 4.167a2.41 2.41 0 0 0 1.825.24 2.404 2.404 0 0 0 1.468-1.123l4.962-8.593a2.34 2.34 0 0 0 .15-2.102zm-11.108.31a1.518 1.518 0 0 1 2.07-.554c.722.417.97 1.348.554 2.07a1.516 1.516 0 0 1-2.07.554 1.518 1.518 0 0 1-.554-2.07zm4.83 6.869A1.516 1.516 0 0 1 9.66 14.93a1.518 1.518 0 0 1 2.069-.555c.722.417.972 1.347.555 2.07zm.572-4.83-5.69 3.285a.284.284 0 1 1-.285-.494l5.69-3.285a.285.285 0 0 1 .285.494zm2.52-5.114a1.505 1.505 0 0 1-1.314.758 1.518 1.518 0 0 1-1.31-2.273 1.518 1.518 0 0 1 2.07-.554c.722.417.972 1.347.555 2.069zm-7.429 3.36a.945.945 0 1 1 1.637.947.945.945 0 0 1-1.637-.946zm14.314-1.38v9.363a2.262 2.262 0 0 1-2.259 2.259h-5.975l4.878-8.45c.474-.82.538-1.72.186-2.6L17.12 4.138a3.048 3.048 0 0 0-.432-.75l-.188-.24.288.098c.245.085.474.21.678.37l3.932 3.09c.564.443.863 1.06.863 1.776zM11.79 16.16a.948.948 0 0 1-1.291.346.946.946 0 1 1 1.291-.346z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.3eddb9ef9101a13704a43df00f39d4a6.svg";
export { ForwardRef as ReactComponent };